export default {
  sm: `
  팔만대장경을 지켜낸 
  ‘장경각’의 정신  
  `,
};
